import { render, staticRenderFns } from "./AppTableRow.vue?vue&type=template&id=ffbe16e0"
import script from "./AppTableRow.vue?vue&type=script&lang=js"
export * from "./AppTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports